export default "__VITE_ASSET__wsWh1Yuk__"